import { Box, CircularProgress } from '@mui/material'
import { useAppTheme } from '@/theme/ThemeContext'

type Props = {
  height?: number | string
  contained?: boolean
}

/**
 * A consistent loading placeholder for charts.
 * Shows a centered spinner with "טוען נתונים..." text.
 */
export default function ChartLoading({ height = 200, contained = true }: Props) {
  const { mode } = useAppTheme()
  const isDark = mode === 'dark'

  return (
    <Box
      sx={{
        height: typeof height === 'number' ? `clamp(180px, ${Math.max(12, height / 10)}vw, ${height}px)` : height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: contained ? (isDark ? '#202B40' : '#FAFBFD') : 'transparent',
        borderRadius: contained ? 2 : 0,
        border: contained ? `1px solid ${isDark ? '#374151' : '#E6ECF2'}` : 'none',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
        <CircularProgress size="clamp(28px, 2.5vw, 42px)" sx={{ color: isDark ? '#60A5FA' : '#254D88' }} />
        <Box sx={{ color: isDark ? '#9CA3AF' : '#6B7280', fontSize: 'clamp(12px, 0.9vw, 16px)', fontFamily: 'Rubik, sans-serif' }}>
          טוען נתונים...
        </Box>
      </Box>
    </Box>
  )
}
